import { useCallback, useState } from "react";

function useLocalStorage<T>(
  key: string,
  initialValue: T,
  options?: { isManual?: boolean }
) {
  const parseLocalStoreValue = useCallback(() => {
    try {
      const item = window.localStorage.getItem(key);
      if (!item) {
        return initialValue;
      }
      if (initialValue instanceof Date) {
        return new Date(JSON.parse(item));
      }
      return JSON.parse(item);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      return initialValue;
    }
  }, [initialValue, key]);

  const [storedValue, setStoredValue] = useState<T>(parseLocalStoreValue);

  const setValue = useCallback(
    (value: T) => {
      try {
        !options?.isManual && setStoredValue(value);
        window.localStorage.setItem(key, JSON.stringify(value));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    [setStoredValue, key, options?.isManual]
  );

  const getManual = useCallback(() => {
    const localStoreValue = parseLocalStoreValue();
    setStoredValue(localStoreValue);
    return localStoreValue;
  }, [parseLocalStoreValue, setStoredValue]);

  return [storedValue, setValue, getManual] as const;
}

export default useLocalStorage;
